export const wording = {
  'edit' : 'Edition',
  'detail' : 'Information',
  'duplicate' : 'Duplication',
  'new' : 'Creation',
  'history' : 'History'
};

